import styled from 'styled-components';

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const OptionsGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const OptionRow = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
`;
